import * as types from './supplierTypeActionTypes';

const initialState = {
  supplierTypeData: null,
  supplierTypeList: [],
  createSupplierTypeData: null,
  createSupplierTypeError: null,
  updateSupplierTypeData: null,
  updateSupplierTypeError: null,
  deleteSupplierTypeData: null,
  deleteSupplierTypeError: null,
};

export const supplierTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_SUPPLIERTYPE_DATA:
      return {
        ...state,
        supplierTypeData: action.payload || null,
        supplierTypeList: action.payload?.SupplierTypeList || [],
      };
    case types.GET_SUPPLIERTYPE_ERROR:
      return { ...state, supplierTypeData: null, supplierTypeList: [] };

    case types.CREATE_SUPPLIERTYPE_DATA:
      return { ...state, createSupplierTypeData: action.payload, createSupplierTypeError: null };
    case types.CREATE_SUPPLIERTYPE_ERROR:
      return { ...state, createSupplierTypeData: null, createSupplierTypeError: action.payload };

    case types.UPDATE_SUPPLIERTYPE_DATA:
      return { ...state, updateSupplierTypeData: action.payload, updateSupplierTypeError: null };
    case types.UPDATE_SUPPLIERTYPE_ERROR:
      return { ...state, updateSupplierTypeData: null, updateSupplierTypeError: action.payload };

    case types.DELETE_SUPPLIERTYPE_DATA:
      return { ...state, deleteSupplierTypeData: action.payload, deleteSupplierTypeError: null };
    case types.DELETE_SUPPLIERTYPE_ERROR:
      return { ...state, deleteSupplierTypeData: null, deleteSupplierTypeError: action.payload };

    default:
      return state;
  }
};


